/*
 * Project: BookingEngine
 * Module: components/booking/rooms/RoomRibbons.js
 * vim:ft=javascript.jsx:
 */
import React from 'react';
import PropTypes from 'prop-types';

import { Ribbon, RibbonOffer } from './Ribbon';

const currentHighlightedPromo = 'PROMOLONGSTAY';

class RoomRibbons extends React.Component {
  hasHighlightedOffer(room, selectedBoard) {
    return selectedBoard.offers.find((offer) => offer.code === currentHighlightedPromo);
  }

  hasBestRateOrValueRibbon(room) {
    return (room.best_rate || room.best_value) && !this.props.discountOnly;
  }

  getDisplayableDiscount(room, selectedBoard) {
    // We return 0 as the ribbon should not be displayed when the hotel does not want discounts shown
    if (!this.props.hotel.booking_show_room_discounts) {
      return 0;
    }

    // Otherwise we return the discount for first currency as they all will have the same discount
    const firstCurrency = Object.keys(selectedBoard.amount)[0];
    return selectedBoard.amount[firstCurrency].discount || 0;
  }

  getRibbonLabel(selectedBoard, hasHighlightedOffer) {
    if (selectedBoard.promocode_applied) {
      return `${this.context.t('Off')} + ${selectedBoard.promocode_applied}`;
    }
    if (hasHighlightedOffer) {
      return this.context.t('Long Stay');
    }
    return this.context.t('Off');
  }

  getDiscountPosition(selectedBoard, hasHighlightedOffer) {
    return selectedBoard.promocode_applied || !hasHighlightedOffer ? 'start' : 'end';
  }

  renderDiscountRibbon(room, selectedBoard, discount_to_show) {
    const discount = this.getDisplayableDiscount(room, selectedBoard);
    if (discount === 0) {
      return null;
    }

    const hasHighlightedOffer = this.hasHighlightedOffer(room, selectedBoard);
    const label = this.getRibbonLabel(selectedBoard, hasHighlightedOffer);
    const discountPosition = this.getDiscountPosition(selectedBoard, hasHighlightedOffer);
    return (
      <RibbonOffer discount={discount} label={label} discountPosition={discountPosition}
      new_member_discount_percentage={this.props.new_member_discount_percentage}
      loyalty_name={this.props.loyalty_name}
      new_member={this.props.new_member}
      new_member_discount_percentage_activated={this.props.new_member_discount_percentage_activated}
      discount_to_show={discount_to_show}
      membershipName={this.props.membershipName}
      agentCode={this.props.agentCode}
      agentSell={this.props.agentSell}
      />
    );
  }

  renderRoomRibbon(room) {
    const hasExtraRibbon = this.hasBestRateOrValueRibbon(room);
    if (!hasExtraRibbon) {
      return null;
    }
    const ribbonText = room.best_rate ? this.context.t('Best Rate') : this.context.t('Recommended');
    return <Ribbon label={ribbonText} background_color={'#005cb9'} color={'#FFFFFF'}/>;
  }

  render() {
    const { room, selectedBoard } = this.props;
    return (
      <div className="ribbon-container">
        {this.renderRoomRibbon(room)}
        {/*this.renderDiscountRibbon(room, selectedBoard, 'NORMAL')*/}
        {this.props.new_member_discount_percentage_activated
        && this.props.new_member
        && this.renderDiscountRibbon(room, selectedBoard, 'NEW_MEMBER_DISCOUNT_PERCENTAGE')}
      </div>
    );
  }
}

RoomRibbons.propTypes = {
  hotel: PropTypes.object.isRequired,
  room: PropTypes.object.isRequired,
  selectedBoard: PropTypes.object.isRequired,
  discountOnly: PropTypes.bool,
  new_member_discount_percentage: PropTypes.number.isRequired,
  loyalty_name: PropTypes.string.isRequired,
  new_member: PropTypes.bool.isRequired,
  new_member_discount_percentage_activated: PropTypes.bool.isRequired,
  membershipName: PropTypes.string.isRequired,
  agentCode: PropTypes.string.isRequired,
  agentSell: PropTypes.string.isRequired,
};

RoomRibbons.defaultProps = {
  discountOnly: false,
};

RoomRibbons.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default RoomRibbons;
